var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.visible ? _c('div', {
    staticClass: "ap-dialog-box",
    class: {
      'ap-dialog-box-show': _vm.animation
    },
    attrs: {
      "id": _vm.id
    }
  }, [_vm.dialogConfig.bgClose ? _c('div', {
    staticClass: "ap-dialog-bg-close",
    class: _vm.dialogConfig.bgClose.class,
    on: {
      "click": _vm.dialogConfig.bgClose.callback
    }
  }) : _vm._e(), _c('div', {
    staticClass: "ap-dialog-content",
    class: {
      'ap-dialog-content-show': _vm.animation,
      'ap-dialog-content-unbutton': _vm.dialogConfig.cancel == null && _vm.dialogConfig.submit == null,
      'ap-dialog-content-has-full-img': _vm.dialogConfig.full && _vm.dialogConfig.full.img
    },
    style: {
      width: _vm.width,
      height: _vm.height,
      backgroundImage: _vm.backgroundImage ? 'url(' + _vm.backgroundImage + ')' : ''
    }
  }, [_vm.dialogConfig.full ? _c('div', {
    staticClass: "ap-dialog-full",
    class: _vm.dialogConfig.full.class,
    on: {
      "click": _vm.fullClick
    }
  }, [_vm.dialogConfig.full.img ? _c('img', {
    attrs: {
      "src": _vm.dialogConfig.full.img
    }
  }) : _vm._e()]) : _vm._e(), _vm.dialogConfig.icon ? _c('div', {
    staticClass: "ap-dialog-icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.dialogConfig.icon
    }
  })]) : _vm._e(), _vm.dialogConfig.title ? _c('div', {
    staticClass: "ap-dialog-title"
  }, [_vm._v("\n      " + _vm._s(_vm.dialogConfig.title) + "\n    ")]) : _vm._e(), _vm.dialogConfig.subTitle ? _c('div', {
    staticClass: "ap-dialog-subTitle"
  }, [_vm._v("\n      " + _vm._s(_vm.dialogConfig.subTitle) + "\n    ")]) : _vm._e(), _vm.dialogConfig.text ? _c('div', {
    staticClass: "ap-dialog-text"
  }, [_vm._v(_vm._s(_vm.dialogConfig.text))]) : _vm._e(), _vm.dialogConfig.html ? _c('div', {
    ref: "content",
    staticClass: "ap-dialog-html"
  }, [_c('div', {
    ref: "contentBody",
    staticClass: "ap-dialog-html-frame",
    domProps: {
      "innerHTML": _vm._s(_vm.dialogConfig.html)
    }
  }), _vm.scroll ? [_c('div', {
    staticClass: "ap-dialog-scroll-header"
  }), _c('div', {
    staticClass: "ap-dialog-scroll-footer"
  })] : _vm._e()], 2) : _vm._e(), _vm.dialogConfig.slot ? _c('div', {
    ref: "content",
    staticClass: "ap-dialog-slot"
  }, [_c('div', {
    ref: "contentBody"
  }, [_c(_vm.dialogConfig.slot, {
    ref: "contentBody",
    tag: "component",
    attrs: {
      "_slotData": _vm.dialogConfig.slotData
    },
    on: {
      "update:_slotData": function update_slotData($event) {
        return _vm.$set(_vm.dialogConfig, "slotData", $event);
      },
      "update:_slot-data": function update_slotData($event) {
        return _vm.$set(_vm.dialogConfig, "slotData", $event);
      }
    }
  })], 1), _vm.scroll ? [_c('div', {
    staticClass: "ap-dialog-scroll-header"
  }), _c('div', {
    staticClass: "ap-dialog-scroll-footer"
  })] : _vm._e()], 2) : _vm._e(), _vm.dialogConfig.cancel || _vm.dialogConfig.submit ? _c('div', {
    staticClass: "ap-dialog-button",
    class: {
      'ap-dialog-button-noBorder': !_vm.dialogConfig.buttonBorder
    }
  }, [_vm.dialogConfig.cancel ? _c('span', {
    staticClass: "ap-dialog-cancel",
    style: _vm.dialogConfig.cancel.style,
    on: {
      "click": _vm.dialogConfig.cancel.callback
    }
  }, [_vm._v("\n        " + _vm._s(_vm.dialogConfig.cancel.name) + "\n      ")]) : _vm._e(), _vm.dialogConfig.submit ? _c('span', {
    staticClass: "ap-dialog-submit",
    style: _vm.dialogConfig.submit.style,
    on: {
      "click": _vm.dialogConfig.submit.callback
    }
  }, [_vm._v("\n        " + _vm._s(_vm.dialogConfig.submit.name) + "\n      ")]) : _vm._e()]) : _vm._e()]), _vm.dialogConfig.closeIcon ? _c('div', {
    staticClass: "ap-dialog-closeIcon",
    class: _vm.dialogConfig.closeIcon.class,
    on: {
      "click": _vm.dialogConfig.closeIcon.callback
    }
  }) : _vm._e()]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };
const __FLY_DATA_ = {};